import { Concepts } from "lib/data/Concepts";
import { Image, RelatedFrameworks, H1, H2, Ol, P, Updated } from "design_lib";

export default function InternationalStrategy() {
  return (
    <div>
      <H1>Definition/Description</H1>

      <P>
        Selecting the appropriate international strategy can be challenging. It must align with your
        company objectives and unique industry pressures. By comparing forces of globalization and
        forces of localization, three main international strategies have emerged, suitable for any
        expansionist company.
      </P>
      <Ol>
        <li>
          Multidomestic Strategy - A strategy whereby global firms respond to differentiated needs
          and preferences in each local market where they operate.
        </li>

        <li>
          Meganational Strategy - A strategy wherein global firms focus on increasing profitable
          growth by reaping cost reductions from economies of scale and other advantages of global
          integration.
        </li>

        <li>
          Transnational Strategy - A strategy where by global firms take a hybrid approach combining
          multidomestic and meganational approaches by simultaneously offering benefits of global
          and local advantages.
        </li>
      </Ol>
      <P>
        By learning about each strategy, business owners can identify which strategy can be the best
        suited to their business.
      </P>

      <Image
        src={require("lib/img/concepts/International_Strategy.png")}
        alt="infographic describing the three international strategies"
      />
      <H1>Examples</H1>
      <H2>Multidomestic - Nestle</H2>
      <P>
        When Nestle expanding to China, it discovered that its globally branded Kitkat bar wasn't
        quite making the impact that it had on other countries. As a result, the Chinese nestle team
        designed produced and marketed a new type of chocolate wafer bar at a fraction of the cost
        of Kitkat. Today, it is the best selling candy bar in China.
      </P>
      <H2>Meganational - ECCO</H2>
      <P>
        The Danish shoe company sells the same shoes all over the world. It applies a similar market
        strategy and has focused manufacturing in a few key countries with competitive advantages in
        shoe production.
      </P>
      <H2>Transnational - GE</H2>
      <P>
        GE is known for having globally standardized procedures but have begun to encourage foreign
        subsidiaries to develop and share innovative new ideas for the rest of the global
        organization. This has enabled multiple products to be developed for local markets such as
        compact and inexpensive heart monitoring devices.
      </P>
      <H1>History</H1>
      <P>
        Two strategy professors at Brigham Young University, Shad Morris and Jim Oldroyd sought to
        standardize the modes of international strategy. In their published book on International
        business, they outlined the above model which differentiated the various expansion modes.
        This model has helped illustrate and grant understanding to the field of international
        strategy.
      </P>

      <RelatedFrameworks
        concepts={[Concepts.Cage, Concepts.BlueOcean, Concepts.EntryModes]}
        unfinishedConcepts={["PEST Framework"]}
      />
      <Updated date="2/21/2025" />
    </div>
  );
}
